import * as Sentry from '@sentry/react';

// @ts-ignore
export const SENTRY_DSN = import.meta.env.ROOT_SENTRY_DSN;
// @ts-ignore
export const SENTRY_TRACES_SAMPLE_RATE = import.meta.env.ROOT_SENTRY_TRACES_SAMPLE_RATE ? Number(import.meta.env.ROOT_SENTRY_TRACES_SAMPLE_RATE) : undefined;
// @ts-ignore
export const SENTRY_REPLAYS_SESSION_SAMPLE_RATE = import.meta.env.ROOT_SENTRY_REPLAYS_SESSION_SAMPLE_RATE ? Number(import.meta.env.ROOT_SENTRY_REPLAYS_SESSION_SAMPLE_RATE) : undefined;
// @ts-ignore
export const SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE = import.meta.env.ROOT_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE ? Number(import.meta.env.ROOT_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE) : 1.0;
// @ts-ignore
export const SENTRY_ENVIROMENT = import.meta.env.ROOT_SENTRY_ENVIRONMENT || 'development';

export const sentryClient = SENTRY_DSN ? Sentry.init({
  dsn: SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration(),
    Sentry.browserTracingIntegration({
      ignoreResourceSpans: ['resource.script', 'resource.css', 'resource.img', 'resource.other']
    }),
    Sentry.captureConsoleIntegration({
      levels: ['error', 'warn']
    })
  ],
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
  // Session Replay
  replaysSessionSampleRate: SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
  replaysOnErrorSampleRate: SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
  environment: SENTRY_ENVIROMENT
}) : undefined;
